import { render } from "./MenuItemYears.vue?vue&type=template&id=6b0d1fe4"
import script from "./MenuItemYears.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuItemYears.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/MenuItemYears.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6b0d1fe4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6b0d1fe4', __exports__)) {
    api.reload('6b0d1fe4', __exports__)
  }
  
  module.hot.accept("./MenuItemYears.vue?vue&type=template&id=6b0d1fe4", () => {
    api.rerender('6b0d1fe4', render)
  })

}


export default __exports__